import React from "react";
import { StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { PageController } from "./features/PageController/PageController";

interface Props {
  theme: any;
  styles: any;
  startupData: any;
}

const App: React.FC<Props> = ({ theme, styles, startupData }): JSX.Element => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <PageController
          classes={classes}
          key={"page"}
          startupData={startupData}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
